import { INVENTORY_SLOTS, ITEMS, type ItemId } from '@xox/shared'
import {
  Flame,
  FlaskConical,
  Gem,
  type LucideIcon,
  Map as MapIcon,
  Shield,
  Snowflake,
  Sparkles,
  Sword,
} from 'lucide-react'

const ICON: Record<ItemId, LucideIcon> = {
  potion: FlaskConical,
  bigPotion: FlaskConical,
  knife: Sword,
  fireScroll: Flame,
  frostScroll: Snowflake,
  teleportScroll: Sparkles,
  revealScroll: MapIcon,
  sword: Sword,
  armor: Shield,
  amulet: Gem,
}

interface Props {
  items: readonly ItemId[]
  onUse: (slot: number) => void
  disabled?: boolean
}

/** Five pockets; tap one to use what is in it (keys 1–5 do the same). */
export function InventoryBar({ items, onUse, disabled = false }: Props) {
  return (
    <ul className="grid w-full max-w-[400px] grid-cols-5 gap-1.5" aria-label="Inventory">
      {Array.from({ length: INVENTORY_SLOTS }, (_, i) => {
        const item = items[i]
        const Icon = item ? ICON[item] : null
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: pockets are fixed positions
          <li key={i}>
            <button
              type="button"
              disabled={disabled || !item}
              onClick={() => onUse(i)}
              title={item ? `${ITEMS[item].name}: ${ITEMS[item].blurb}` : 'Empty'}
              aria-label={item ? `Use ${ITEMS[item].name} (${i + 1})` : `Pocket ${i + 1}, empty`}
              className="flex h-14 w-full flex-col items-center justify-center gap-0.5 rounded-xl bg-white text-[10px] font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200 active:scale-95 disabled:opacity-40 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700"
            >
              {Icon ? (
                <Icon className="size-5" aria-hidden />
              ) : (
                <span className="text-slate-300">{i + 1}</span>
              )}
              <span className="max-w-full truncate px-1">{item ? ITEMS[item].name : ''}</span>
            </button>
          </li>
        )
      })}
    </ul>
  )
}
